import { css } from 'styled-system/css';

export const Styles = {
	chatroom: css({
		'&:not([data-chatroom-open=true])': {
			'.aside-panel--video &': {
				_mars: {
					m: 0,
					width: '100%',
				},
			},
		},
		'&[data-chatroom-open=true]': {
			'.aside-panel--video &': {
				_mars: {
					p: 0,
				},
			},
		},
	}),
};

